import { ERROR, LOADING, LOADING_DETAILS, SUCCESS, SUCCESS_DETAILS } from './CTHActions';

const INITIAL_STATE = {
  isLoading: true,
  detailsIsLoading: true,
  success: false,
  error: '',
  data: [],
  details: [],
  isFatTailed: undefined
};

const CTHReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case LOADING_DETAILS: {
      return { ...state, detailsIsLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case SUCCESS_DETAILS: {
      return { ...state, detailsIsLoading: false, details: action.data, isFatTailed: action.isFatTailed };
    }
    default:
      return state;
  }
};

export default CTHReducer;
